var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCrossFunctionalIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 118,
    height: 123,
    viewBox: "0 0 118 123",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M95.9015 23.0654C99.6002 23.0654 102.6 26.0632 102.6 29.7598C102.6 33.4565 99.6002 36.4542 95.9015 36.4542C92.2029 36.4542 89.188 33.441 89.188 29.7598C89.188 26.0787 92.1873 23.0654 95.9015 23.0654Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4624 93.6601C18.4624 89.9635 21.4617 86.9502 25.1604 86.9502C28.8591 86.9502 31.874 89.9635 31.874 93.6601C31.874 97.3568 28.8591 100.355 25.1604 100.355C21.4617 100.355 18.4624 97.3723 18.4624 93.6601Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M59.0081 108.602C62.7223 108.602 65.7061 111.599 65.7061 115.296C65.7061 118.993 62.7223 121.99 59.0081 121.99C55.2939 121.99 52.3101 119.008 52.3101 115.296C52.3101 111.584 55.3094 108.602 59.0081 108.602Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M59.0081 1.00977C62.7223 1.00977 65.7061 3.99196 65.7061 7.70417C65.7061 11.4164 62.7223 14.3986 59.0081 14.3986C55.2939 14.3986 52.3101 11.4009 52.3101 7.70417C52.3101 4.00749 55.3094 1.00977 59.0081 1.00977Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M94.969 86.9502C98.6521 86.9502 101.667 89.9635 101.667 93.6601C101.667 97.3568 98.6677 100.355 94.969 100.355C91.2703 100.355 88.271 97.3723 88.271 93.6601C88.271 89.9479 91.2703 86.9502 94.969 86.9502Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M23.1868 36.4542C19.4726 36.4542 16.4888 33.441 16.4888 29.7598C16.4888 26.0787 19.4726 23.0654 23.1868 23.0654C26.901 23.0654 29.8848 26.0632 29.8848 29.7598C29.8848 33.4565 26.8855 36.4542 23.1868 36.4542Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M25.1604 86.9502C28.8746 86.9502 31.874 89.9635 31.874 93.6601C31.874 97.3568 28.8591 100.355 25.1604 100.355C21.4617 100.355 18.4624 97.3723 18.4624 93.6601C18.4624 89.9479 21.4617 86.9502 25.1604 86.9502Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M50.1806 45.4474V29.7598H29.8845H29.4805",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M31.2056 93.6594H31.8738H50.1807V74.7256",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M23.1868 23.0654C26.8855 23.0654 29.8848 26.0632 29.8848 29.7598C29.8848 33.4565 26.8855 36.4542 23.1868 36.4542C19.4881 36.4542 16.4888 33.441 16.4888 29.7598C16.4888 26.0787 19.4726 23.0654 23.1868 23.0654Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M94.969 86.9502C91.2703 86.9502 88.271 89.9635 88.271 93.6601C88.271 97.3568 91.2703 100.355 94.969 100.355C98.6677 100.355 101.667 97.3723 101.667 93.6601C101.667 89.9479 98.6677 86.9502 94.969 86.9502Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M68.9229 45.3386V29.7598H89.1878H89.623",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M87.8824 93.6594H68.9229V74.7256",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M95.9015 23.0654C92.1873 23.0654 89.188 26.0632 89.188 29.7598C89.188 33.4565 92.1873 36.4542 95.9015 36.4542C99.6158 36.4542 102.6 33.441 102.6 29.7598C102.6 26.0787 99.6002 23.0654 95.9015 23.0654Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M59.0078 74.7256V108.601V109.067",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M59.0078 14.1504V14.3989V45.246",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M59.0081 1.00977C62.7223 1.00977 65.7061 3.99196 65.7061 7.70417C65.7061 11.4164 62.7223 14.3986 59.0081 14.3986C55.2939 14.3986 52.3101 11.4009 52.3101 7.70417C52.3101 4.00749 55.3094 1.00977 59.0081 1.00977Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M59.0081 108.602C62.7223 108.602 65.7061 111.599 65.7061 115.296C65.7061 118.993 62.7223 121.99 59.0081 121.99C55.2939 121.99 52.3101 119.008 52.3101 115.296C52.3101 111.584 55.3094 108.602 59.0081 108.602Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M1.01025 45.5098H116.99",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M1.01025 74.6797H116.99",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrossFunctionalIcon);
export default __webpack_public_path__ + "static/media/CrossFunctional_icon.55a1a8ddb859b867cdbee5fa51971f38.svg";
export { ForwardRef as ReactComponent };